import { connect } from 'react-redux';
import Component from './component';
import { hideMessage } from '../../actions/message';

export default connect(
  (state) => ({
    messages: state.message.values
  }),
  //Dispatches
  (dispatch) => ({
    hideMessage: (id) => dispatch(hideMessage(id))
  })
)(Component);



// WEBPACK FOOTER //
// ./src/components/Messages/index.js